import type { AiScrubScope } from '../../../models';

// The sessionStorage key for a batch run's persisted id. Country-awards runs are per (award, country),
// so the key MUST include countryId - otherwise a run persisted for one country is restored for another
// country under the same award. Awards scope keeps its historical key shape (no countryId) so existing
// awards persistence and the legacy-key migration continue to work.
export const sessionKey = (awardId: number, scope: AiScrubScope, countryId?: number): string =>
  scope === 'country-awards'
    ? `aiScrubBatchRunId:${scope}:${awardId}:${countryId ?? ''}`
    : `aiScrubBatchRunId:${scope}:${awardId}`;
